import { FC } from 'react'
import { SvgProps } from './svgProps'

const TracksuitIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width || 14}
    height={height || 32}
    viewBox="0 0 14 32"
  >
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M2.418 0.419h9.23v2.137h-9.23v-2.137z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M13.651 31.581v-24.45c-0.004-1.806-0.771-3.432-1.995-4.573l-0.004-0.003h-9.228c-1.231 1.144-2 2.77-2.005 4.575v24.451h4.404l2.213-22.256 2.215 22.256z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M3.146 2.726c0.207 0.342 0.33 0.755 0.33 1.197 0 0.57-0.204 1.092-0.542 1.498l0.003-0.004c-0.455 0.606-1.172 0.993-1.98 0.993-0.126 0-0.251-0.010-0.372-0.028l0.014 0.002"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="0.8389"
      stroke={color || '#000'}
      d="M10.845 2.726c-0.207 0.342-0.33 0.755-0.33 1.197 0 0.57 0.204 1.092 0.542 1.498l-0.003-0.004c0.456 0.601 1.17 0.985 1.974 0.985 0.127 0 0.252-0.010 0.374-0.028l-0.014 0.002"
    ></path>
  </svg>
)

export default TracksuitIcon
